<div id="helpful-links" class="helpful-links-container">
  <ul class="list list-unstyled">
    <li>
      <a id="updatesLink" class="item" [routerLink]="['/display']" i18n>Map & Software Updates</a>
    </li>
    @if (!selectedVehicle || selectedVehicle?.hasDisplay) {
      <li>
        <a id="tutorialsLink" class="item" [routerLink]="['/display', 'tutorials']" i18n>Ride Command Tutorials</a>
      </li>
    }
    @if (selectedVehicle) {
      <li>
        <a
          id="maintenanceLogLink"
          class="item"
          [routerLink]="['/maintenance', 'vehicle', selectedVehicle.id, 'records']"
          i18n
          >Maintenance Log</a
        >
      </li>
    }
    @if (isIndian || isSlingshot) {
      <li>
        <a id="ridersGroupLink" class="item" target="_blank" [href]="groupUrl"
          ><span i18n>Riders Group</span>
          <svg-icon class="external-links-icon" src="/assets/icons/external-link.svg" />
        </a>
      </li>
    }
    <li>
      <a id="measurementLink" class="item link-item" [href]="" (click)="navigateTo()" i18n
        >Change System of Measurement</a
      >
    </li>
  </ul>
</div>
